<div
  class="timeline-row tw-relative tw-isolate tw-flex tw-flex-col tw-items-center tw-self-center tw-w-full lg:tw-max-w-[976px] xl:tw-max-w-[1296px]"
  [ngClass]="{ 'tw-mb-12 lg:tw-mb-16': !isLast() }"
>
  <app-event-dates-status
    [event]="event()"
    class="tw-relative tw-z-10  tw-w-full lg:tw-w-max"
  ></app-event-dates-status>

  <!-- Spacer between status strip and card (line runs through via absolute rail below) -->
  <div class="tw-h-2 tw-w-full tw-shrink-0 tw-hidden lg:tw-block" aria-hidden="true"></div>

  <div
    class="tw-relative tw-z-10 tw-w-full tw-pt-2 tw-pb-0 lg:tw-p-3 lg:tw-pb-2 xl:tw-p-4  xl:tw-pb-3 lg:tw-bg-white lg:tw-border lg:tw-border-gray-200 lg:tw-rounded-2xl tw-flex tw-flex-col"
  >
    <app-event-header
      [event]="event()"
      [archived]="model().card.archived"
      [canEdit]="canEdit()"
      [canCreate]="canCreate()"
      [dropdownOptions]="headerDropdownOptions()"
      [cloning]="headerCloning()"
      [cloningMessage]="headerCloningMessage()"
      (modalStateChanged)="onModalStateChanged($event)"
      (cloneConfirmed)="onCloneConfirmed()"
      (archiveConfirmed)="onArchiveConfirmed()"
      (restoreConfirmed)="onRestoreConfirmed()"
    ></app-event-header>
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-2 xl:tw-gap-4">
      <app-event-card
        [core]="cardCore()"
        [personasState]="cardPersonas()"
        [dropdownOptions]="cardDropdownOptions()"
        (bannerChanged)="onBannerChanged($event)"
        (personaAction)="onPersonaAction($event)"
        (eventsChanged)="onEventsChanged($event)"
        (modalStateChanged)="onModalStateChanged($event)"
        (archiveUpdateChanged)="onArchiveUpdateChanged($event)"
        (restoreConfirmed)="onRestoreConfirmed()"
        class="tw-w-full lg:tw-w-1/2 xl:tw-w-[624px] lg:tw-max-h-[624.25px] xl:tw-max-h-[582px]"
      ></app-event-card>
      <app-event-power-ups
        class="tw-w-full lg:tw-w-1/2 xl:tw-w-[624px] lg:tw-max-h-[624.25px] xl:tw-max-h-[582px]"
        [readonly]="isInteractionReadonly()"
        [hasPersonas]="eventHasPersonas()"
        [eventVenueCity]="event().location_details?.venue_city"
        (powerUpClicked)="onPowerUpClicked($event)"
      ></app-event-power-ups>
    </div>
  </div>

  <!-- Desktop (lg+): centered rail from under status through card and tw-mb-16 gap. -->
  @if (!isLast()) {
    <div
      class="tw-pointer-events-none tw-absolute tw-left-1/2 tw-z-0 tw-hidden tw--translate-x-1/2 tw-border-l-2 tw-border-dashed tw-border-gray-300 tw-w-0 lg:tw-block lg:tw-top-[62px] lg:tw-bottom-[-4rem]"
      aria-hidden="true"
    ></div>
  } @else {
    <div
      class="tw-pointer-events-none tw-absolute tw-left-1/2 tw-z-0 tw-hidden tw--translate-x-1/2 tw-border-l-2 tw-border-dashed tw-border-gray-300 tw-w-0 lg:tw-block lg:tw-top-[62px] lg:tw-bottom-0"
      aria-hidden="true"
    ></div>
  }

  <!-- Mobile: no line above the card — only a left rail in the margin below the card (matches tw-mb-16). -->
  @if (!isLast()) {
    <div
      class="tw-pointer-events-none tw-absolute tw-left-8 tw-top-full tw-z-0 tw-h-16 tw-w-0 tw-border-l-2 tw-border-dashed tw-border-gray-300 lg:tw-hidden"
      aria-hidden="true"
    ></div>
  }

</div>
